// extracted by mini-css-extract-plugin
export default {"row":"collaborator-form_row__wjiqW","containerField":"collaborator-form_containerField__1K-oB"};